import { Box, Container } from '@mui/material'
// biome-ignore lint/style/useImportType: <This is not a type-only import>
import React from 'react'

export const FullWidthLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Box sx={{ width: '100%', minHeight: '100vh' }}>{children}</Box>

export const CenteredLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Container maxWidth="md" sx={{ padding: 2 }}>
    {children}
  </Container>
)

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Container maxWidth="lg" sx={{ padding: 2 }}>
    {children}
  </Container>
)
